module.exports = __webpack_public_path__ + "img/mariage-shop-card.4b944c31.png";